<template>
    <div>
        <div class="form-row col-12 px-0">
            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Data ostatniej aktualizacji od'"
                    custom-id="date-from"
                    name="date-from"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateFrom"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być wcześniejsza niż data końcowa') }}
                </small>
            </div>

            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Data ostatniej aktualizacji do'"
                    custom-id="date-to"
                    name="date-to"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateTo"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być późniejsza niż data początkowa') }}
                </small>
            </div>
            <div class="form-group ml-2">
                <input type="checkbox" id="diff_only" name="diff_only" checked>
                <label for="diff_only">{{$lang('Wyświetl tylko rozbieżności')}}</label>
            </div>
        </div>
    </div>
</template>

<script>
import ValidDate from "../../../mixins/report-valid-date";
export default {
    name: 'comparison-jira-sos-statuses',
    mixins: [ ValidDate],
    computed: {
        valid() {
            return this.dateFrom !== '-' && this.dateTo !== '-' && this.dateFrom<=this.dateTo;
        }
    },
    watch: {
        valid() {
            this.$emit('validation', this.valid);
        }
    },
    created() {
        const today = new Date();
        const firstDay = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        const lastDay = today;
        this.dateFrom = firstDay.getFullYear() + '-' + ('0' + (firstDay.getMonth() + 1)).slice(-2) + '-' + ('0' + firstDay.getDate()).slice(-2);
        this.dateTo = lastDay.getFullYear() + '-' + ('0' + (lastDay.getMonth() + 1)).slice(-2) + '-' + ('0' + lastDay.getDate()).slice(-2);
    }
}
</script>
